<template>
    <div class="py-2 container-fluid">
        <div class="row">
            <div class="mx-auto col-lg-9 col-12">
                <div class="mt-4 card card-body">
                    <h6 class="mb-0">{{ id == 'new' ? 'Novo Informativo' : 'Editar Informativo' }}</h6>
                    <p class="mb-0 text-sm">Criar/Editar Informativo Login Hotel</p>
                    <hr class="my-3 horizontal dark" />

                    <form role="form" @submit.prevent="onSubmit">
                        <div v-if="isSubmitting" class="loading-overlay">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Enviando...</span>
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-md-12">
                                <label>Titulo</label>
                                <argon-input id="name" type="text" placeholder="Titulo" aria-label="Titulo"
                                    v-model="v$.informativo.titulo.$model" text-case="upper" />
                                <div class="input-errors" v-for="(error, index) of v$.informativo.titulo.$errors" :key="index">
                                    <div class="text-danger text-xs">{{ error.$message }}</div>
                                </div>
                            </div>
                            
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="descricaoInformativo">Descrição</label>
                                    <textarea
                                        id="descricaoInformativo"
                                        class="form-control"
                                        rows="5"
                                        v-model="v$.informativo.descricao.$model" placeholder="Descrição do Informativo"
                                    ></textarea>
                                </div>
                                <div class="input-errors" v-for="(error, index) of v$.informativo.descricao.$errors" :key="index">
                                    <div class="text-danger text-xs">{{ error.$message }}</div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <label>Link Botão</label>
                                <argon-input id="name" type="text" placeholder="Descrição" aria-label="Descrição"
                                    v-model="v$.informativo.link.$model" text-case="upper" />
                            </div>
                            <div class="col-md-3">
                                <label>Data Final</label>
                                <datepicker v-model="v$.informativo.dataFinal.$model" minimum-view="day"
                                    class="form-control text-bold text-center date-input" :locale="locale"
                                    input-format="dd/MM/yyyy" placeholder="DD/MM/AAAA" />

                                <div class="input-errors" v-for="(error, index) of v$.informativo.dataFinal.$errors" :key="index">
                                    <div class="text-danger text-xs">{{ error.$message }}</div>
                                </div> 
                            </div>
                            <div class="col-md-12">
                                <div class="image-upload-container">
                                    <label for="imageUpload" class="image-upload-label">
                                        <div class="image-upload-preview" v-if="informativo.urlImg">
                                            <img :src="informativo.urlImg" alt="Preview da imagem" />
                                        </div>
                                        <div class="image-upload-placeholder" v-else>
                                            <i class="fas fa-cloud-upload-alt"></i>
                                            <span>Clique para carregar imagem</span>
                                        </div>
                                    </label>
                                    <input 
                                        type="file" 
                                        id="imageUpload" 
                                        @change="handleImageUpload" 
                                        accept="image/*"
                                        class="image-upload-input"
                                        >
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <router-link :to="{ name: 'Informativos Login Hotel' }">
                                <argon-button type="button" color="dark" class="my-4 mb-2">
                                    Voltar
                                </argon-button>
                            </router-link>
                            <argon-button type="submit" color="success" variant="gradient" class="my-4 mb-2">
                                SALVAR
                            </argon-button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators'
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import api from '@/services/api';
import Datepicker from 'vue3-datepicker'
import { errorToast, successToast } from '@/utils/alerts';

export default {
    name: "InformativoLogin",
    components: {
        ArgonInput,
        ArgonButton,
        Datepicker
    },
    created() {
        this.id = this.$route.params.id;

        if (this.id == 'new') {
            return;
        }

        this.fetchData();
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    data() {
        return {
            id: null,
            informativo: {
                titulo: '',
                descricao: '',
                dataFinal: null,
                link: '',
                urlImg: null,
            },
            imageFile: null, // Armazena o arquivo de imagem para upload
            allowedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'] // Extensões permitidas
        }
    },
    validations() {
        return {
            informativo: {
                titulo: {
                    required: helpers.withMessage('titulo é obrigatório', required),
                },
                descricao: {
                    required: helpers.withMessage('Descrição é obrigatório', required),
                },
                dataFinal: {
                    required: helpers.withMessage('Data final é obrigatório', required),
                },
                link: {

                },
                urlImg: {

                }
            },
        }
    },
    methods: {
        fetchData() {
            const { id } = this;

            api.get(`/informativos-login/${id}`)
                .then(({ data }) => {
                this.informativo = data;
                const dataFinal = new Date(this.informativo.dataFinal);
                this.informativo.dataFinal = dataFinal;
                
                // Se tiver uma URL de imagem, obter a URL assinada
                if (this.informativo.urlImg) {
                    // Extrair a chave da URL do S3 (tudo depois de .com/)
                    const key = this.informativo.urlImg.split('.com/').pop();
                    
                    if (key) {
                        api.get(`/s3/image/${key}`)
                            .then(response => {
                                this.informativo.urlImg = response.data.url;
                            })
                            .catch(error => {
                                console.error('Erro ao obter URL assinada:', error);
                            });
                    }
                }
            })
            .catch(() => errorToast('Erro ao carregar informativo'));
        },
        async onSubmit() {
            const isFormValid = await this.v$.$validate();

            if (!isFormValid) {
                return;
            }

            this.isSubmitting = true;

            try {
                // Criar um FormData para enviar os dados + arquivo
                const formData = new FormData();
                
                // Adicionar os dados do informativo
                Object.keys(this.informativo).forEach(key => {
                    if (key !== 'urlImg' || this.id !== 'new') { // Não envia urlImg em novo registro
                        // Formatar a data final para o formato esperado pelo PostgreSQL (YYYY-MM-DD)
                        if (key === 'dataFinal' && this.informativo[key]) {
                            const date = new Date(this.informativo[key]);
                            const formattedDate = date.toISOString().split('T')[0];
                            formData.append(key, formattedDate);
                        } else {
                            formData.append(key, this.informativo[key]);
                        }
                    }
                });

                // Adicionar o arquivo se existir
                if (this.imageFile) {
                    formData.append('file', this.imageFile);
                }

                // Configurar headers para multipart/form-data
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                await (this.id == 'new' ?
                    api.post('/informativos-login', formData, config) :
                    api.patch(`/informativos-login/${this.id}`, formData, config));

                successToast('Informativo salvo com sucesso.');

                this.$router.push({ name: 'Informativos Login Hotel' });

            } catch (e) {
                const { data } = e;
                const message = data ? data.message : e.message;
                errorToast(message)
            } finally {
                this.isSubmitting = false;
            }
        },

        handleImageUpload(event) {
            const file = event.target.files[0];
            
            if (file) {
                const extension = file.name.split('.').pop().toLowerCase();
                
                if (this.allowedExtensions.includes(extension)) {
                    // Guardar o arquivo para envio posterior
                    this.imageFile = file;

                    // Criar preview da imagem
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.informativo.urlImg = e.target.result;
                    };
                    reader.readAsDataURL(file);
                } else {
                    errorToast(`Formato de arquivo não permitido. Use: ${this.allowedExtensions.join(', ')}`);
                    event.target.value = ''; // Limpa o input
                }
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.image-upload-container {
  width: 100%;
  height: 300px;
  margin: 20px auto;
}

.image-upload-label {
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: 2px dashed #ccc;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.image-upload-label:hover {
  border-color: #007bff;
}

.image-upload-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.image-upload-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #777;
}

.image-upload-placeholder i {
  font-size: 48px;
  margin-bottom: 10px;
}

.image-upload-input {
  display: none;
}
</style>